// \src\lib\fetchPitanieCategoryTagProducts.ts

export interface Product {
    id: number;
    name: string;
    slug: string;
    sku: string;
    price: string;
    stock_quantity: number;
    stock_status: string;
    images: { src: string; alt: string }[];
    brands: { id: number; name: string; slug: string }[];
}

export interface CategoryTagProductsResponse {
    products: Product[];
    total: number;
    totalPages: number;
}

export async function fetchCategoryTagProducts(
    categorySlug: string,
    tagSlug: string,
    page: number,
    perPage: number
): Promise<CategoryTagProductsResponse> {
    const apiUrl = `https://retail.vitaline.uz/wp-json/vitaline/v1/category-products?category=${categorySlug}&tag=${tagSlug}&page=${page}&per_page=${perPage}&orderby=stock_quantity&order=desc`;

    try {
        const response = await fetch(apiUrl, {
            next: { revalidate: 3600 }, // Кэширование на 1 час
        });

        if (!response.ok) {
            throw new Error('Failed to fetch products');
        }

        const data = await response.json();
        const total = parseInt(response.headers.get('X-WP-Total') || '0');
        const totalPages = parseInt(response.headers.get('X-WP-TotalPages') || '0');

        return {
            products: data.products || [],
            total,
            totalPages,
        };
    } catch (error) {
        console.error('Error fetching category and tag products:', error);
        return { products: [], total: 0, totalPages: 0 };
    }
}